// AUTO-GENERATED by scripts/generate-page-schema.mjs from the Choice Wealth schema
// workbook. Do not hand-edit -- update the sheet and rerun the script.
//
// Per-page JSON-LD, one ./pages/<RouteMatch["type"]>.json per sheet row, injected
// into <head> by the SEO effect in App.tsx via ensureJsonLd. Each sheet row is a
// complete @graph that already carries its own Organization / WebSite nodes, so a
// page with a row emits that row alone; routes with no row fall back to
// CW_IDENTITY_SCHEMA (the Home row graph). Emitting both would put two nodes
// sharing an @id but holding different values into one document.
//
// The page graphs load through a lazy import.meta.glob so each route pulls only its
// own block (2-12 kB) instead of shipping all 35 in the entry chunk.
//
// Only the logo URLs are adjusted from the sheet: its /assets/images/logo.png and
// its path-to-logo.png / path-to-your-logo.png placeholders do not exist on this
// site, so all three point at /choice-logo.svg.

export const CW_IDENTITY_SCHEMA: object = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://choicewealth.in/#organization",
      "name": "Choice Wealth",
      "url": "https://choicewealth.in/",
      "logo": {
        "@type": "ImageObject",
        "url": "https://choicewealth.in/choice-logo.svg"
      },
      "sameAs": [
        "https://www.facebook.com/people/Choice-Wealth/61576080547338/",
        "https://www.linkedin.com/company/choicewealth",
        "https://www.youtube.com/@choicewealthsocial",
        "https://www.instagram.com/choicewealthsocial"
      ]
    },
    {
      "@type": "WebSite",
      "@id": "https://choicewealth.in/#website",
      "url": "https://choicewealth.in/",
      "name": "Choice Wealth",
      "publisher": {
        "@id": "https://choicewealth.in/#organization"
      },
      "inLanguage": "en-IN"
    },
    {
      "@type": "FinancialService",
      "@id": "https://choicewealth.in/#financialservice",
      "name": "Choice Wealth",
      "url": "https://choicewealth.in/",
      "provider": {
        "@id": "https://choicewealth.in/#organization"
      },
      "areaServed": {
        "@type": "Country",
        "name": "India"
      },
      "serviceType": [
        "Wealth Management",
        "Investment Advisory",
        "Portfolio Management Services",
        "Alternative Investment Funds",
        "Mutual Funds Advisory",
        "Retirement Planning"
      ]
    }
  ]
};

const PAGE_SCHEMA_LOADERS = import.meta.glob<{ default: object }>("./pages/*.json");

/** Route types the sheet has a row for, for the identity-vs-page-graph decision. */
export const PAGE_SCHEMA_ROUTES: ReadonlySet<string> = new Set(
  Object.keys(PAGE_SCHEMA_LOADERS).map((file) =>
    file.slice("./pages/".length, -".json".length),
  ),
);

export async function loadPageSchema(routeType: string): Promise<object | null> {
  const load = PAGE_SCHEMA_LOADERS[`./pages/${routeType}.json`];
  if (!load) {
    return null;
  }
  try {
    return (await load()).default;
  } catch {
    return null;
  }
}
